import { AbstractFacade } from '@goparrot/axios';
import deepmerge from 'deepmerge';
export class BaseVendorFacade extends AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_VENDOR_V2,
                },
            },
            config,
        ]), interceptors);
    }
}
//# sourceMappingURL=BaseVendorFacade.js.map